// extracted by mini-css-extract-plugin
export var statItem = "_in-1";
export var statsRow = "_in-0";